import { defineMessages } from "react-intl";

export const messages = defineMessages({
  translate: {
    id: "f2Yqtd",
    defaultMessage: "Translate",
    description: "shipping tone rates translate",
  },
});
